<template>
<!-- 合作伙伴滚动 -->
<div class="partners">
    <div class="partner-wrapper-section clearfix w-1200">
        <h2>供应链伙伴</h2>
        <img src="../assets/partners/left.png" class="left">
        <div class="marquee">
            <div class="marquee-content" @mouseover="clearTimer" @mouseout='startTimer'>
              <img src="../assets/partners/logo_10.png" alt="">
              <img src="../assets/partners/logo_11.png" alt="">
              <img :src="require('../assets/partners/logo_'+i+'.png')" alt="" v-for="i in 11" :key="i">
              <img src="../assets/partners/logo_1.png" alt="">
              <img src="../assets/partners/logo_2.png" alt="">
              <img src="../assets/partners/logo_3.png" alt="">
            </div>
        </div>
        <img src="../assets/partners/right.png" class="right">
    </div>
</div>
</template>

<script>
export default {
  name: 'partners',
  components: {
  },
  data () {
    return {
      imglists: [],
      timer: ''
    }
  },
  created () {
  },
  mounted () {
    this.startTimer()
  },
  methods: {
    clearTimer () {
      clearInterval(this.timer)
    },
    startTimer () {
      var content = document.querySelector('.marquee-content')
      this.timer = setInterval(() => {
        var oldleftstr = getComputedStyle(content, null).left
        var oldleft = parseInt(oldleftstr)
        content.style.left = oldleft - 1 + 'px'
        if (oldleft <= -2235) {
          content.style.left = 0
        }
      }, 10)
    }
  }

}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.partners{
      border-bottom: 1px solid rgba(219, 218, 224, 0.6);
      .partner-wrapper-section{
        margin: 0 auto;
        padding: 0;
        position: relative;
        h2{
          float: left;
          width: 200px;
          height: 140px;
          line-height: 140px;
          font-size: 28px;
          color: #282828;
          text-align: left;
          box-sizing: border-box;
        }
        .left,.right{
          position: absolute;
          height: 140px;
          top: 0;
        }
        .left{
          left: 200px;
          z-index: 1;
        }
        .right{
          right: -10px;
        }
        .marquee {
          /* width: 100%; */
          height: 140px;
          line-height: 140px;
          margin: 0 auto;
          position: relative;
          overflow: hidden;
          margin-left: 200px;
        }
        .marquee-content {
          width: 3243px;
          position: absolute;
          left: -335px;
          height: 140px;
          line-height: 140px;
            img {
            display: inline-block;
            vertical-align: middle;
            // width: 200px;
            height: 60px;
          }
        }
      }
    }
</style>
